import { Role } from '../types/coreApi-types'

export function isAdmin(role: Role) {
  const adminRoles: Role[] = [
    'Admin',
    'ComplianceOfficer',
    'FinanceOfficer',
    'OperationsOfficer',
    'Bookkeeper',
  ]
  return adminRoles.includes(role)
}

export function isBookkeeper(role: Role) {
  return role === 'Bookkeeper'
}

// Roles allowed to view a customer's fee structure — mirrors the server's RolePermissions mapping for
// Users_ViewInvestorFeeStructure. Fee structure is a commercial concern, so compliance / operations /
// bookkeeping staff are deliberately excluded (least privilege); keep this in lockstep with
// RolePermissions.cs. (AdminApplication also holds the permission server-side but is a machine-to-machine
// identity that never renders this UI.)
export function canViewInvestorFeeStructure(role: Role) {
  return role === 'Admin' || role === 'FinanceOfficer'
}

// Roles allowed to change a customer's login email — mirrors the server's RolePermissions mapping for
// Users_ChangeEmail (Admin / ComplianceOfficer / OperationsOfficer). Identity-sensitive, so view-only and
// machine roles are excluded; keep this in lockstep with RolePermissions.cs.
export function canChangeUserEmail(role: Role) {
  return (
    role === 'Admin' ||
    role === 'ComplianceOfficer' ||
    role === 'OperationsOfficer'
  )
}

export function isPartner(role: Role) {
  return role === 'Partner'
}

export function isWealthManager(role: Role) {
  return role === 'WealthManager'
}
